import { useEffect, useState } from 'react';
import apiService from 'services/BackendApi/BackendApi';

export const PAGES_NODES = {
	TERMS_AND_CONDITIONS: 1,
	DISCLAIMER: 2,
	FAQ: 3,
	PRIVACY_POLICY: 4,
};
export function useInformationPage(props) {
	//const { page } = props;
	const { alias } = props;
	const [pageContent, setPageContent] = useState({
		isLoading: false,
		isError: false,
		payload: null,
		error: null,
	});

	useEffect(() => {
		setPageContent((prevPageContent) => ({
			...prevPageContent,
			isLoading: true,
		}));
		apiService
			.GetPageInfo({
				urlParams: {
					alias: alias,
				},
				params: {
					_format: 'json',
				},
			})
			.then((response) => {
				setPageContent((prevPageContent) => ({
					...prevPageContent,
					isError: false,
					payload: {
						title: response.data.title[0].value,
						body: response.data.body[0].processed,
					},
				}));
			})
			.catch((error) => {
				setPageContent((prevPageContent) => ({
					...prevPageContent,
					isError: true,
					error: error,
				}));
			})
			.finally(() => {
				setPageContent((prevPageContent) => ({
					...prevPageContent,
					isLoading: false,
				}));
			});
	}, [alias]);

	return pageContent;
}
